import { render, staticRenderFns } from "./farm-info.vue?vue&type=template&id=27247ef5&scoped=true&"
import script from "./farm-info.vue?vue&type=script&lang=ts&"
export * from "./farm-info.vue?vue&type=script&lang=ts&"
import style0 from "./farm-info.vue?vue&type=style&index=0&id=27247ef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27247ef5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
